import React, {useEffect, useState} from 'react';
import {Field, useField, useFormikContext} from 'formik';
import styles from './Field.module.css';

const FieldPeriodicite = ({ name }) => {
    const { values, setFieldValue } = useFormikContext();
    const [showPeriodicitePar, setShowPeriodicitePar] = useState(false);

    useEffect(() => {
        const shouldShow = values.periodicite === '2' || values.periodicite === '3';
        setShowPeriodicitePar(shouldShow);

        let combinedValue = (+values.periodicite) * 100;
        combinedValue += (+values.periodicite_par) * 10;
        combinedValue += (+values.periodicite_nb);

        setFieldValue('periodiciteCombined', combinedValue);
    }, [values.periodicite_nb, values.periodicite, values.periodicite_par, setFieldValue]);

    return (
        <div className={styles.fieldPeriodiciteContainer}>
            <label htmlFor="periodicite_nb">Répéter tous les</label>
            <Field name={"periodicite_nb"} type={"number"} max={10} min={1}/>
                <Field as="select" name="periodicite">
                    <option name="periodicite" value="1">semaine(s)</option>
                    <option name="periodicite" value="2">mois</option>
                    <option name="periodicite" value="3">année(s)</option>
                </Field>
                {showPeriodicitePar && (
                    <>
                        <Field as="select" name="periodicite_par">
                            <option value="0">une semaine par {values.periodicite === '2' ? 'mois' : 'année'}</option>
                            <option value="1">toutes les semaines {values.periodicite === '2' ? 'du mois' : "de l'année"}</option>
                        </Field>
                        <div className={styles.periodiciteParDescription}>
                            {values.periodicite_par === '0' ? (
                                <p style={{
                                    fontStyle: "italic",
                                    fontSize: "var(--fs-primary)"
                                }}><strong>Option "une semaine par"</strong>: Sélectionner cette option pour choisir les dates pour une seule semaine dans le mois
                                    ou l'année. Par exemple, "Répéter tous les 2 années une fois par", si la date de
                                    début est le 15 janvier 2020, sélectionnera tous les lundis suivant le 15 janvier
                                    tous les deux ans (par ex. 17 janvier 2022, 15 janvier 2024, etc.).
                                </p>
                            ) : (
                                <p style={{
                                    fontStyle: "italic",
                                    fontSize: "var(--fs-primary)"
                                }}><strong>Option "toutes les semaines"</strong>: Sélectionner cette option pour choisir toutes les occurrences dans l'année ou le
                                    mois. Par exemple, "Répéter tous les 2 années complet", si la date de début est le
                                    15 janvier 2020, sélectionnera tous les lundis de 2022, 2024, etc.
                                </p>
                            )}
                        </div>
                    </>
                )}
            <Field type="hidden" name={name}/>
        </div>
    );
};


export default FieldPeriodicite;